import Button from '../ui/Button';
import { FormButtons, FormContent, FormPair} from '../ui/Form';
import React from 'react';

function SignIn({ updateFormState, disabled }) {

  return (
    <FormContent>
      <FormPair>
        <label>Username: </label>
        <input
          type='text'
          name='username'
          onChange={e => {updateFormState(e)}}
          placeholder='username'
          required
        />
      </FormPair>
      <FormPair>
        <label>Password: </label>
        <input
          type='password'
          name='password'
          onChange={e => {updateFormState(e)}}
          placeholder='password'
          required
        />
      </FormPair>
      <FormButtons>
        <Button type='submit'  >Sign In</Button>
      </FormButtons>
    </FormContent>
  )
}

export default SignIn